export {
  armNativeSplashFailsafe,
  hideNativeSplash,
  suppressWebSplashOnNative,
} from './nativeSplash';
